import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminGuard = ({ children }) => {
    const userRole = localStorage.getItem('user_role');
    const token = localStorage.getItem('token');

    if (!token) {
        return <Navigate to="/login" replace />;
    }

    if (userRole !== 'admin') {
        return <Navigate to="/cockpit" replace />;
    }

    return children;
};

export default AdminGuard;
